import React from 'react';
import Helmet from 'react-helmet';
import { getCurrentLangKey, getLangs, getUrlForLang } from 'ptz-i18n';
import { IntlProvider, addLocaleData } from 'react-intl';
import 'intl';

import '../index.scss';

import Site from './Site';
import IndexHeader from './IndexHeader';
import Header from './Header';
import Footer from './Footer';

import en from 'react-intl/locale-data/en';
import 'intl/locale-data/jsonp/en';
import ru from 'react-intl/locale-data/ru';
import 'intl/locale-data/jsonp/ru';

addLocaleData([...ru, ...en]);

function flattenMessages(nestedMessages, prefix = '') {
    return Object.keys(nestedMessages).reduce((messages, key) => {
        let value = nestedMessages[key];
        let prefixedKey = prefix ? `${prefix}.${key}` : key;

        if (typeof value === 'string') {
            messages[prefixedKey] = value;
        } else {
            Object.assign(messages, flattenMessages(value, prefixedKey));
        }

        return messages;
    }, {});
}

function Fragment(props) {
    return props.children || <span {...props} /> || null;
}

export default class Layout extends React.Component {
    render() {
        const { children, data, location } = this.props;
        const { langs, defaultLangKey } = data.site.siteMetadata.languages;
        const url = location.pathname;
        const langKey = getCurrentLangKey(langs, defaultLangKey, url);
        const pathPrefix = `/${langKey}/`;
        const isIndexPage = url === pathPrefix;
        const langsMenu = getLangs(
            langs,
            langKey,
            getUrlForLang(pathPrefix, url)
        );

        const i18nMessages = flattenMessages(
            require(`../../data/messages/${langKey}`)
        );

        const HeaderComponent = isIndexPage ? IndexHeader : Header;

        return (
            <IntlProvider
                locale={langKey}
                messages={i18nMessages}
                textComponent={Fragment}
            >
                <Site>
                    <Helmet
                        title={data.site.siteMetadata.title}
                        meta={[
                            { name: 'description', content: '' },
                            { name: 'keywords', content: '' },
                        ]}
                        script={[
                            {
                                src:
                                    'https://use.fontawesome.com/releases/v5.0.7/js/all.js',
                            },
                        ]}
                        link={[
                            {
                                rel: 'stylesheet',
                                href:
                                    'https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css',
                            },
                        ]}
                    />
                    <HeaderComponent langs={langsMenu} />
                    {children(this.props)}
                    <Footer
                        data={data[langKey === 'ru' ? 'footerRu' : 'footerEn']}
                    />
                </Site>
            </IntlProvider>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/components/Layout.js